import { render, staticRenderFns } from "./intercom_integration.vue?vue&type=template&id=6f968320&scoped=true&"
import script from "./intercom_integration.vue?vue&type=script&lang=js&"
export * from "./intercom_integration.vue?vue&type=script&lang=js&"
import style0 from "./intercom_integration.vue?vue&type=style&index=0&id=6f968320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f968320",
  null
  
)

export default component.exports